<template>
    <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="优惠券类型：">
              <el-select style="width: 200px;" v-model="formInline.couponType" filterable placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                  <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="关键字：">
              <el-input v-model="formInline.name" placeholder="请输入优惠券名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search()">搜索</el-button>
            <el-button type="primary" @click="showAdd()">新建</el-button>
          </el-form-item>
      </el-form>
      <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="优惠券名称" show-overflow-tooltip>
          <template #default="scope">
            <div>
              <span>{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="优惠券类型">
          <template #default="scope">
            <div>
              <span>{{ typeFilter(scope.row.couponType) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="优惠券渠道">
          <template #default="scope">
            <div>
              <span>{{ channelFilter(scope.row.channel) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="券值（面值/折扣系数）">
          <template #default="scope">
            <div>
              <span>{{ scope.row.couponValue || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="发放门槛（单位：元）">
          <template #default="scope">
            <div>
              <span>{{ scope.row.issueThreshold || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="200">
          <template #default="scope">
            <div>
              <span>{{ scope.row.createTime || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="200">
          <template #default="scope">
            <div>
              <span>{{ scope.row.updateTime || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="scope">
            <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
              编辑
            </el-button>
            <el-button
              size="small"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <Pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
  
      <!-- 对话框--新建、编辑组织 -->
      <el-dialog v-model="dialogFormVisible" :title="dialogTitle" width="500" :close-on-click-modal="false" @closed="$refs.addFormRef?.clearValidate()">
          <el-form ref="addFormRef" label-position="right" label-width="auto" :model="addInfo" :rules="addRules">
          <el-form-item label="优惠券名称" prop="name">
            <el-input v-model="addInfo.name" autocomplete="off" />
          </el-form-item>
          <el-form-item label="优惠券类型" prop="couponType">
            <el-select v-model="addInfo.couponType" filterable placeholder="请选择">
                  <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="优惠券渠道" prop="channel">
            <el-select v-model="addInfo.channel" filterable placeholder="请选择">
                  <el-option
                  v-for="item in channelOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="券值（面值/折扣系数）" prop="couponValue">
            <el-input v-model="addInfo.couponValue" autocomplete="off" />
          </el-form-item>
          <el-form-item label="发放门槛（单位：元）" prop="issueThreshold">
            <el-input v-model="addInfo.issueThreshold" autocomplete="off" />
          </el-form-item>
          <el-form-item label="生效时间" prop="effectiveTime">
            <el-date-picker
                v-model="addInfo.effectiveTime"
                type="datetime"
                value-format="YYYY-MM-DD HH:mm:ss"
                placeholder="选择生效时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="失效时间" prop="expirationTime">
            <el-date-picker
                v-model="addInfo.expirationTime"
                type="datetime"
                value-format="YYYY-MM-DD HH:mm:ss"
                placeholder="选择失效时间"
            >
            </el-date-picker>
          </el-form-item>
          </el-form>
          <template #footer>
          <div class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取消</el-button>
              <el-button type="primary" @click="saveInfo()">确定</el-button>
          </div>
          </template>
      </el-dialog>
  
      <!-- 对话框--删除 -->
      <el-dialog
        v-model="centerDialogVisible"
        title="提示"
        width="500"
        align-center
      >
        <span>确定删除该优惠券吗？</span>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="deleteUser()">确定</el-button>
          </div>
        </template>
      </el-dialog>
  
    </template>
    
    <script>
    import { required, isPrice, isNumber, isNonNegative } from '@/utils/validators';
    export default {
    name:'ParkCouponList',
    data() {
      return {
        formInline:{
          couponType:'',
          name:''
        },
        typeOptions:[
          {
            label:'金额减免',
            value:1
          },
          {
            label:'时长减免',
            value:2
          },
          {
            label:'折扣优惠',
            value:3
          },
          {
            label:'全免',
            value:4
          }
        ],
        channelOptions:[
          {
            label:'平台',
            value:0
          },
          {
            label:'捷顺',
            value:1
          }
        ],
        isUpdate:false,
        dialogTitle:'添加分成方',
        dialogFormVisible:false,
        centerDialogVisible:false,
        currt_id:'', //当前操作id
        tableData:[],
        addFormRef: null,
        addRules: {
          name: [required('请输入优惠券名称')],
          couponType: [required('请选择优惠券类型')],
          channel: [required('请选择优惠券渠道')],
          couponValue: [required('请输入券值'), isPrice('券值只能是大于0的数字'), isNonNegative('券值不能为负数')],
          issueThreshold: [required('请输入发放门槛'), isPrice('发放门槛只能是大于0的数字'), isNonNegative('发放门槛不能为负数')],
          effectiveTime: [required('请选择生效时间')],
          expirationTime: [required('请选择失效时间')],
        },
        addInfo:{
          name:'',
          couponType:'',
          channel:'',
          couponValue:'',
          issueThreshold:'',
          effectiveTime:'',
          expirationTime:''
        },
        total: 0, //总条数
        currentPage: 1, //当前页
        pageSize: 10, //每页显示条数
      }
    },
    components: {
      
    },
    computed: {
      filteredMessage() {
        // 这里可以实现类似过滤器的转换逻辑
      }
    },
    beforeCreate(){
      
    },
    created(){
      
    },
    mounted(){
      this.getList();
    },
    methods:{
      handleSizeChange (val) { //每页显示条数
          this.pageSize = val;
          this.currentPage = 1;
          this.getList();
      },
      handleCurrentChange(val) { //当前页
          this.currentPage = val;
          this.getList(); //获取列表
      },
      search(){
        //搜索
        let that = this;
        let param = {};
        param.page = 1;
        param.pageSize = this.pageSize;
        param.name = that.formInline.name;
        param.couponType = that.formInline.couponType;
        that.$axios.post(that.$store.state.platformApi+"park/coupon/page",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.tableData = result.data.records;
            that.total = result.data.total;
          }
        })
      },
      getList(){
        //获取列表
        let that = this;
        let param = {};
        param.page = this.currentPage;
        param.pageSize = this.pageSize;
        param.name = that.formInline.name;
        param.couponType = that.formInline.couponType;
        that.$axios.post(that.$store.state.platformApi+"park/coupon/page",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.tableData = result.data.records;
            that.total = result.data.total;
          }
        })
      },
      saveInfo(){
        //保存
        let that = this;
        // 表单校验
        this.$refs.addFormRef.validate((valid) => {
          if (!valid) return;
          let param = {};
          var url = that.$store.state.platformApi+"park/coupon/add";
          param = this.addInfo;
          if(that.isUpdate){
            //编辑
            param.id = that.currt_id;
          }
          param.couponNo = 'a';
          that.$axios.post(url,JSON.stringify(param)).then(result => {
            if(result.code==200){
              // 保存成功
              that.dialogFormVisible = false;
              that.getList();
            }
          });
        });
      },
      showAdd(index,row){
        //打开添加弹窗
          this.isUpdate = false;
          this.dialogTitle = '添加优惠券';
          this.addInfo = Object.fromEntries(
            Object.keys(this.addInfo).map(key => [key, ''])
          );
          this.dialogFormVisible = true;
      },
      handleEdit(index,row){
        //打开编辑
        this.dialogTitle = '编辑优惠券';
        this.isUpdate = true;
        this.dialogFormVisible = true;
        this.addInfo = row;
        this.currt_id = row.id;
      },
      deleteUser(){
        //删除
        let that = this;
        that.$axios.post(that.$store.state.platformApi+"park/coupon/delete/"+that.currt_id).then(result => {
          // console.log(result);
          if(result.code==200){
            that.centerDialogVisible = false;
            that.getList();
          }
        })
      },
      handleDelete(index,row){
          //删除弹窗
        this.centerDialogVisible = true;
        this.currt_id = row.id;
      },
      typeFilter(value) {
        //过滤函数
        switch (value) {
          case 1:
            return '金额减免券';
          case 2:
            return '时长减免券';
          case 3:
            return '折扣优惠券';
          case 4:
            return '全免优惠券';
          default:
            return value;
        }
      },
      channelFilter(value) {
        //过滤函数
        switch (value) {
          case 0:
            return '平台';
          case 1:
            return '捷顺';
          default:
            return value;
        }
      },
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .search_nav{
      width: 100%;
      height: 60px;
  }
  </style>